export const endpoints = {
  oidcConfiguration: (client: string) => `/api/v1/configuration/oidc?client=${client}`
};
